import Cookies from "js-cookie"

const TokenKey = 'Authorization'
export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token, {
    })
}
export function getCookie(name) {
    return Cookies.get(name)
}

export function setCookie(name, value) {
    return Cookies.set(name, value)
}

export function removeCookie(name) {
    return Cookies.remove(name)
}

export function setsession(name, value) {
    return window.sessionStorage.setItem(name, value)
}

export function getsession(name) {
    return window.sessionStorage.getItem(name)
}

export function removesession(name) {
    return window.sessionStorage.removeItem(name)
}

export function clearsession() {
    return window.sessionStorage.clear()
}